'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/scroll-behavior/~/dom-helpers/util/inDOM.js
 ** module id = 462
 ** module chunks = 0
 **/